import React from 'react';

export default function PlayBtnIcon() {
  return (
    <svg style={{ marginLeft: '-6px' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.25 11.567C20.5833 11.7594 20.5833 12.2406 20.25 12.433L8.25 19.3612C7.91667 19.5537 7.5 19.3131 7.5 18.9282L7.5 5.0718C7.5 4.6869 7.91667 4.44634 8.25 4.63879L20.25 11.567Z" fill="currentColor" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
